/// Somebody is writing, at the end of the thread: who, and the three dots under it.
///
/// Drawn where that person's messages are — the technician's on the left, the office's on the
/// right — so it reads as coming from them before it is read at all.
///
/// A name only where it settles something. On the right there is a room of dispatchers and admins
/// all writing into the same conversation, and a name is what tells one colleague from another;
/// on the left there is one technician and the side already says so.
export default function ChatTypingBubble(props: {
    names: (string | undefined)[]
    /// On our own side: somebody else in the office.
    mine?: boolean
}) {

    const people = props.names.filter(n => !!n) as string[];

    const said = () => {
        if (people.length === 0) return "";
        if (people.length === 1) return `${people[0]} is typing`;
        if (people.length === 2) return `${people[0]} and ${people[1]} are typing`;
        return `${people.slice(0, -1).join(", ")} and ${people[people.length - 1]} are typing`;
    }

    return (
        <div className={`chat-typing-bubble ${props.mine ? "chat-typing-bubble-mine" : ""}`}>
            {people.length > 0 && <div className="chat-typing-bubble-name">{said()}</div>}
            <div className="chat-typing-dots">
                <span></span>
                <span></span>
                <span></span>
            </div>
        </div>
    )
}
